import React, { useEffect, useState } from "react";
import { useCatalogs } from "../general/hooks";
import { Input } from "./Input";

const QUOTES_REGEX = /['"]/;

export default ({
  t,
  fields,
  values,
  lng,
  updateEntityInfo,
  FIELDS_WITHOUT_QUOTES,
  errors = {},
}) => {
  const {
    incotermCatalog,
    uomCatalog,
    transportModeCatalog,
    uomCatalogD,
    uomCatalogO,
    uomCatalogQ,
    uomCatalogT,
    uomCatalogV,
    uomCatalogW,
  } = useCatalogs(lng);
  const [poInfo, setPoInfo] = useState(values);
  const [isOpen, setIsOpen] = useState({});

  useEffect(() => {
    setPoInfo(values);
  }, [values]);

  const handleChange = (id, value) => {
    const hasRestrictedFields =
      FIELDS_WITHOUT_QUOTES && typeof FIELDS_WITHOUT_QUOTES.has === "function";

    if (hasRestrictedFields && FIELDS_WITHOUT_QUOTES.has(id)) {
      if (QUOTES_REGEX.test(value)) {
        return;
      }
    }
    let newPoInfo = { ...poInfo };
    newPoInfo[id] = value;
    updateEntityInfo(id, value);
    setPoInfo(newPoInfo);
  };

  const handleCheckbox = (id) => {
    let newPoInfo = { ...poInfo };
    newPoInfo[id] = Number(!Boolean(newPoInfo[id]));
    handleChange(id, newPoInfo[id]);
  };

  const findCatalog = (catalogName) => {
    switch (catalogName) {
      case "incotermCatalog":
        return incotermCatalog;
      case "uomCatalog":
        return uomCatalog;
      case "transportModeCatalog":
        return transportModeCatalog;
      case "uomCatalogO":
        return uomCatalogO;
      case "uomCatalogV":
        return uomCatalogV;
      case "uomCatalogT":
        return uomCatalogT;
      case "uomCatalogW":
        return uomCatalogW;
      case "uomCatalogQ":
        return uomCatalogQ;
      case "uomCatalogD":
        return uomCatalogD;
      default:
        return [];
    }
  };

  const findInCatalog = (values, id, catalogName) => {
    let catalog = findCatalog(catalogName);
    let value = catalog.find((item) => {
      return item.value === values[id] || item.label === values[id];
    });
    if (value && value.value !== poInfo[id]) {
      handleChange(id, value.value);
    }
    return value || null;
  };

  const handleOpen = (id, open) => {
    let newIsOpen = { ...isOpen };
    newIsOpen[id] = open;
    setIsOpen(newIsOpen);
  };

  return fields.map((field, index) => (
    <div
      className={field.class}
      style={{ paddingTop: "1%" }}
      key={`${field.id}-${index}-edit`}
    >
      <Input
        field={field}
        t={t}
        values={poInfo}
        errors={errors}
        handleChange={handleChange}
        handleCheckbox={handleCheckbox}
        handleOpen={handleOpen}
        findCatalog={findCatalog}
        findInCatalog={findInCatalog}
        lng={lng}
        isOpen={isOpen}
      />
    </div>
  ));
};
